<template>
  <el-input-number
    v-if="isEditor"
    v-model="value"
    :min="item?.minLength"
    :max="item?.maxLength"
    :step="step"
    :controls="controls"
    :controls-position="controlsPosition"
  />
  <div v-else>{{ value }}</div>
</template>
<script>
import { defineComponent } from 'vue'
import { baseProps, controlItemManage } from '../control-web/index'
export default defineComponent({
  name: 't-number',
  inheritAttrs: false,
  props: {
    ...baseProps,
    modelValue: { type: Number },
    controls: { type: Boolean, default: false }, //是否显示控制按钮
    controlsPosition: { type: String, default: '' }, //控制按钮位置
    step: { type: Number, default: 1 } //步长
  },
  emits: ['update:modelValue', 'my-change'],
  setup(props, context) {
    return {
      ...controlItemManage(props, context)
    }
  }
})
</script>
